import { PaymentServicePath } from "utils/constants";

export const paymentRequests = {
  changeBankTransferStatus: id => `${PaymentServicePath}bank-transfers/${id}/status`,
  payCashPayment: transactionId => `${PaymentServicePath}cash-payments/${transactionId}/pay`,

  getIbansSelect: () => `${PaymentServicePath}ibans/selects`,
  getEshopsSelect: () => `${PaymentServicePath}eshops/select`,
  getPaymentProvidersSelect: () => `${PaymentServicePath}providers/select`,
};
